import React from 'react';
import { Button } from './Button';
import { Icon } from './Icon';
import styles from './Feedback.module.css';

export function EmptyState({
  message = 'No records found.',
  subtext,
  action,
  className = ''
}) {
  return (
    <div className={`${styles.emptyState} ${className}`}>
      <span className={styles.emptyDash} aria-hidden="true">—</span>
      <p className={styles.emptyMessage}>{message}</p>
      {subtext && <p className={styles.emptySubtext}>{subtext}</p>}
      {action && <div className={styles.emptyAction}>{action}</div>}
    </div>
  );
}

export function Loader({ text = 'Loading data…', className = '' }) {
  return (
    <div className={`${styles.loaderContainer} ${className}`} role="status">
      <span className={styles.loaderText}>{text}</span>
      <div className={styles.loaderBar}>
        <div className={styles.loaderProgress} />
      </div>
    </div>
  );
}

export function ErrorState({
  error,
  message = 'An error occurred while loading data.',
  onRetry,
  className = ''
}) {
  const errMsg = error?.message || (typeof error === 'string' ? error : message);

  return (
    <div className={`${styles.errorState} ${className}`} role="alert">
      <div className={styles.errorIcon}>
        <Icon name="alert" size={24} />
      </div>
      <div className={styles.errorContent}>
        <h3 className={styles.errorTitle}>Request Exception</h3>
        <p className={styles.errorMessage}>{errMsg}</p>
      </div>
      {onRetry && (
        <Button
          variant="outline"
          size="sm"
          onClick={onRetry}
          icon={<Icon name="refresh" size={14} />}
        >
          Retry
        </Button>
      )}
    </div>
  );
}
